
import React, { useEffect,useState, Fragment } from 'react'
import Layout from "../../components/Layout/Layout";
import { SearchIcon, QuestionMarkCircleIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon } from "@heroicons/react/outline";
import BillsServices from '../../services/BillsServices';
import ActionDropdown from "../../components/ActionDropdown";
import { convert, formatDate, DisplayCurrentTime } from './../../utils/convertDate';
import Paginate from '../../utils/Paginate';
import DatePicker from 'react-date-picker';
import { Link } from 'react-router-dom';

const statusStyles = {
    Active: 'bg-green-500 text-white',
    Expired: 'bg-orange-600 text-white',
    Exhausted: 'bg-amber-400 text-white'
}

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Movies() {
    const [movie, setMovie] = useState([]);
    const [pageIndex, setPageIndex] = useState(1);
    const [prevPage, setPrev] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [search, setSearch] = useState("");
    const [totalPage, setPage] = useState(0);
    const [nextPage, setNextPage] = useState(false);
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [status, setStatus] = useState("");
    const [pageLength, setPageLength] = useState("");
    const oldFrom = new Date().setDate(new Date().getDate() - 7);
    const [formValues, setFormValues] = useState({
        from: new Date(oldFrom),
        to: new Date()
    })
    const defaultTo = formatDate(new Date());
    const longNew = formatDate(defaultTo);
    const [too, setToo] = useState(convert(longNew));
    const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
    const longDate = formatDate(defaultFrom);
    const [fromm, setFromm] = useState(convert(longDate));

    const listMovieUsers = async (search, from, to, status) => {
        const list = await BillsServices.listMovieUsers(pageIndex, 10, search, from, to, status);
        setMovie([...list.data.result]);
        setPageLength([...list.data.result].length);
        setPageNumber(list.data.totalCount)
        setPageIndex(list.data.pageIndex)
        setPrev(list.data.hasPreviousPage);
        setPage(list.data.totalPages);
        setNextPage(list.data.hasNextPage);

    }
    const listMovie = async () => {
        listMovieUsers(search, fromm, too, status);      
    }
    const setSort = async (e) => {
        const selectedValue = e.target.value;
        if (selectedValue === "All") {
            setStatus("");
        } else {
            setStatus(selectedValue);
        }
        listMovieUsers(search, fromm, too, selectedValue !== "All" ? selectedValue : "");
    }
    


    const range = async (e) => {
        e.preventDefault();
        const newDate = formatDate(formValues.from)
        setFrom(formValues.from)
        var longDate = formatDate(newDate);
        setFromm(convert(longDate));

        const toDate = formatDate(formValues.to);
        setTo(formValues.to)
        setToo(convert(toDate));

        listMovieUsers(search, convert(newDate), convert(toDate), status); 
    }
    const dateValidation = {
        fromHandler: (event) => {
            setFormValues({ ...formValues, from: event })
        },
        toHandler: (event) => {
            setFormValues({ ...formValues, to: event })
        }
    }; 

    const exportCSV = async () => {
        const resp = await BillsServices.exportMovieUsers(search, fromm, too, status);
        window.open(resp.data);
    }
    const searchp = async (text) => {
        setSearch(text);       
    };


    useEffect(() => {
        listMovie();
    }, [pageIndex])
    return (<>
        <Layout title={'Movie Subscription'} pageTag={'payment'} current={'/payment/movies'}>
            <React.Fragment>
                <main>
                    <div className='max-w-7xl mx-auto '>

                        <div className="px-4 sm:px-6 lg:px-8">
                            <div className="mt-4 sm:mt-0 sm:ml-6 flex justify-end">
                                <button
                                    type="button"
                                    onClick={exportCSV}
                                    className="inline-flex hover:text-white active:text-white mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm sm:w-auto"
                                >
                                    <DocumentDownloadIcon className="w-4 mr-1.5" />
                                    Export CSV
                                </button>
                            </div>
                            <div className="sm:flex sm:items-center">
                                <div className="sm:flex-auto flex">

                                    <div className="relative rounded-md shadow-sm ml-3">
                                        <p className='text-sm leading-3 text-gray-500'>From</p>
                                        <div>
                                            <DatePicker
                                            onChange= {dateValidation.fromHandler}
                                            value={formValues.from} />
                                        </div>
                                    </div>
                                    <div className=" relative rounded-md shadow-sm ml-3">
                                        <p className='text-sm leading-3 text-gray-500'>To</p>
                                        <div>
                                            <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                                        </div>
                                    </div>
                                    <div className='flex'>
                                        <div className="mt-5 ml-4 relative rounded-md shadow-sm">
                                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                            </div>
                                            <input
                                                type="text"
                                                onChange={(e) =>
                                                    searchp(e.target.value)
                                                }
                                                name="search"
                                                id="search"
                                                className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                                placeholder="Search "
                                            />
                                            <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                                                <div className='tooltip'>
                                                    <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                                                    <span className="tooltiptext"> <p>Search by name, email address </p></span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="mt-5 relative rounded-md shadow-sm ml-3">
                                        <select
                                            id="currency"
                                            onChange={(e) => setSort(e)}
                                            name="currency"
                                            placeholder="Sort by"
                                            className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                        >
                                            <option value="All">Filter by</option>
                                            <option value="All">All</option>
                                            <option value={"Active"}>Active</option>
                                            <option value={"Exhausted"}>Exhausted</option>
                                            <option value={"Expired"}>Expired</option>
                                        </select>
                                    </div>
                                    <div className='mt-5 ml-4'>
                                        <button
                                            onClick={range}
                                            className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                                    </div>
                                    
                                </div>
                            </div>
                            {movie.length === 0 ? (
                                <div className=" mt-8"> No data available for these dates to show. </div>
                            ) :
                                <>
                                    <div className="mt-8 flex flex-col">
                                        <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                            <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                                <div className="relative ring-1 ring-black ring-opacity-5 md:rounded-lg">
                                                    <table className="min-w-full table-fixed divide-y divide-gray-300">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col" className="pl-3 min-w-[6rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                                    Username
                                                                </th>
                                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                    Firstname
                                                                </th>
                                                                <th scope="col" className="px-3 pl-3 min-w-[10rem]  py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                    Lastname
                                                                </th> <th scope="col" className="px-3 pl-3 min-w-[10rem]  py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                    Email Address
                                                                </th>
                                                                <th scope="col" className="px-3 pl-3 min-w-[10rem]  py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                    Gender
                                                                </th>
                                                                <th scope="col" className="pl-3 min-w-[12rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                    No of movies remaining
                                                                </th>
                                                                <th scope="col" className="pl-3 min-w-[8rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                    Status
                                                                </th>

                                                                <th scope="col" className=" pl-3 min-w-[10rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                    Date Created
                                                                </th>
                                                                <th scope="col" className=" pl-3 min-w-[10rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                    Time Created
                                                                </th>
                                                                <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                                    Expiry Date
                                                                </th>

                                                            </tr>
                                                        </thead>
                                                        <tbody className="divide-y divide-gray-200 bg-white">
                                                            {movie.map((person, i) => (
                                                                <tr key={i} className="bg-gray-50">
                                                                    <td className=" pr-3 whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.userName}</td>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.firstName}</td>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.surname}</td>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.email}</td>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.gender}</td>

                                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{person.numberOfMoviesRemaining}</td>
                                                                    <td><span className={classNames(
                                                                        statusStyles[person.status], "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900")}>{person.status}</span>
                                                                    </td>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{formatDate(person.dateCreated)}</td>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{DisplayCurrentTime(person.dateCreated)}</td>
                                                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-900">{formatDate(person.dateExpiry)}</td>
                                                                    <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                                                        <ActionDropdown
                                                                          items={[
                                                                            { label: "View Subscriptions", onClick: () => window.location.href = `/payment/view-movie?id=${person.userName}` },
                                                                          ]}
                                                                          dropdownWidth="w-40"
                                                                        />

                                                                    </td>

                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <Paginate
                                    nextPage={nextPage}
                                    pageIndex={pageIndex}
                                    totalCount={pageNumber}
                                    totalPages={totalPage}
                                    prevPage={prevPage}
                                    setPageIndex={setPageIndex}
                                />
                                </>
                            }


                        </div>
                    </div>
                </main>

            </React.Fragment>
        </Layout></>)
}